export default "__VITE_ASSET__D$hYvdLz__"